import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/GlobalAccessManagementPageQuery$parameters';
import type { GlobalAccessManagementPageQuery } from './__generated__/GlobalAccessManagementPageQuery.graphql';
import type { JiraProjectAccessActorFilterInput } from './__generated__/SpaceRoleActorTablePaginationQuery.graphql';

/**
 * ⚠️ Keep in sync with `DEFAULT_FILTERS` and `mapFiltersToInput` in
 * `mapFiltersToInput.tsx`. If the default filter state or mapping changes, update
 * this value too.
 */
const DEFAULT_PRELOAD_FILTERS: JiraProjectAccessActorFilterInput[] = [
	{ filterType: 'PROJECT_STYLE', values: ['COMPANY_MANAGED_PROJECT'] },
];

type GlobalAccessManagementEntryPointComponent = EntryPointComponent<
	{
		globalAccessManagement: GlobalAccessManagementPageQuery;
	},
	{},
	{},
	{
		cloudId: string;
		isAdmin: boolean;
	}
>;

export const globalAccessManagementEntryPoint: EntryPoint<
	GlobalAccessManagementEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GlobalAccessManagementEntryPointComponent>(
		/* webpackChunkName: "async-global-access-management-page" */ './GlobalAccessManagementPageRoot.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId, isAdmin } }: EntryPointRouteParams) => ({
		queries: {
			globalAccessManagement: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId,
					filters: DEFAULT_PRELOAD_FILTERS,
					includeAvailableRoles: fg('jira-access-page-fast-follow-1'),
				},
			},
		},
		extraProps: {
			cloudId,
			isAdmin,
		},
	}),
});
